import runtimeEnv from '~/shared/utils/runtimeEnv';

import { launchDarklyContextPath, type LaunchDarklyInitConfig } from './openFeatureSetup';

export interface FetchLaunchDarklyInitConfigOptions {
  accessToken?: string;
}

function resolveFeatureContextUrl(): string {
  const baseUrl = runtimeEnv.apiBaseUrl.replace(/\/$/, '');
  return `${baseUrl}${launchDarklyContextPath}`;
}

export async function fetchLaunchDarklyInitConfig({
  accessToken,
}: FetchLaunchDarklyInitConfigOptions): Promise<LaunchDarklyInitConfig> {
  const response = await fetch(resolveFeatureContextUrl(), {
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
  });

  if (!response.ok) {
    const error = new Error(response.statusText || 'Failed to fetch LaunchDarkly context') as Error & {
      status?: number;
    };
    error.status = response.status;
    throw error;
  }

  const config = (await response.json()) as LaunchDarklyInitConfig;

  // Context is validated once, right before it reaches LaunchDarkly (see mapLaunchDarklyContextToOpenFeature).
  return config;
}
